import { styled } from "styled-components";

export const ModalContent = styled.div`
  background-color: #fff;
  width: 834px;
  height: 70%;
  padding: 20px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
